<script>
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    components: {
        VueDatePicker,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        onChange: {
            type: Function,
            required: false
        },
        modeltype: {
            type: String,
            default: 'HH:mm',
        },
        inputtype: {
            type: String,
            default: 'HH:mm',
        },
    },
    computed: {
        model: {
            get() {
                if (!this.value) return null

                return this.value;
            },
            set(val) {
                if (this.onChange)
                    this.onChange(val);
            },
        },
    },
}
</script>

<template>
    <VueDatePicker v-model="model" time-picker :is-24="true" :model-type="modeltype"
        :formats="{ input: inputtype }" auto-apply teleport="body" />
</template>
